import styled from 'styled-components'

const Wrap = styled.div`
  padding: 0 5px;
`
const Container = styled.label`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
  border-radius: 25px;
  outline: none;
`
const Label = styled.span`
  padding: 0 0 0 10px;
  font-size: 14px;
  height: 24px;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  a {
    color: var(--orange);
    text-decoration: underline;
    padding: 0 3px;
    font-weight: bold;
    &:hover {
      color: var(--orange);
    }
  }
`
const SwitchButton = styled.span`
  background-color: var(--light-gray);
  border: 2px solid var(--light-gray);
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: all ease 0.5s;
  border-radius: 25px;
  width: 50px;
  height: 24px;

  &:before {
    position: absolute;
    content: '';
    height: 16px;
    width: 16px;
    left: 2px;
    top: 2px;
    background-color: #fff;
    transition: left ease 0.5s;
    border-radius: 50%;
  }
`
const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0.01;
  &:checked {
    & + span {
      background-color: var(--dark-blue);
      border-color: var(--dark-blue);

      &:before {
        background-color: #fff;
        left: calc(100% - 18px);
      }
    }
  }
  &:focus {
    & + span {
      outline: none;
      border: 2px solid black;
    }
  }
`
export { Container, Label, SwitchButton, Checkbox, Wrap }
